/* eslint-disable no-case-declarations */
import _ from 'lodash';
import { order as mockOrder } from 'mocks/hire/order';

/**
 * 
 * @param {*[]} state 
 * @param {{ type: DispatchTypes, payload?: any }} action 
 * @returns 
 */
export const reducer = (state, action) => {
    switch (action.type) {
    case 'ADD_ORDER':
        return [...state, mockOrder];
    case 'REMOVE_ORDER':
        return state.slice(0, -1);
    case 'CLEAR_ORDERS':
        return [mockOrder];
    case 'UPDATE_ORDER':
        const stateCopy = _.cloneDeep(state);
        const { payload: { index, value } } = action;

        stateCopy[index] = value;

        return stateCopy;   
    default:
        return state;
    }
};

/**
 * @typedef {React.Dispatch<{type: DispatchTypes; payload?: any;}>} TDispatchHireOrders
 */

/**
 * @typedef {'ADD_ORDER' | 'REMOVE_ORDER' | 'CLEAR_ORDERS' | 'UPDATE_ORDER'} DispatchTypes
 */



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Hire/hireOrdersReducer.js